import { PropsWithChildren } from 'react';
import { Container } from '~/components/layout';

export const Page = ({ children }: PropsWithChildren<{}>) => <Container>{children}</Container>;
